import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type PatientSyncState, usePatientSync } from 'providers/PatientSyncProvider';
import { isElectron } from 'utils/environment';
import { PatientSyncStopDialog } from './PatientSyncStopDialog';
import { StatusButton, StatusIcon } from './PatientSyncStatusIndicator.styles';
import loadingIcon from './icons/loading.svg?inline';
import outOfSyncIcon from './icons/out-of-sync.svg?inline';
import syncStoppedIcon from './icons/sync-stopped.svg?inline';
import syncedIcon from './icons/synced.svg?inline';

const ICONS: Record<PatientSyncState, { src: string; labelKey: string }> = {
  loading: {
    src: loadingIcon,
    labelKey: 'patientSync.statusIndicator.loading',
  },
  synced: {
    src: syncedIcon,
    labelKey: 'patientSync.statusIndicator.synced',
  },
  'out-of-sync': {
    src: outOfSyncIcon,
    labelKey: 'patientSync.statusIndicator.outOfSync',
  },
  'sync-stopped': {
    src: syncStoppedIcon,
    labelKey: 'patientSync.statusIndicator.syncStopped',
  },
};

export function PatientSyncStatusIndicator() {
  const { t } = useTranslation();
  const { syncState, stopSync, startSync } = usePatientSync();
  const [isStopDialogOpen, setStopDialogOpen] = useState(false);

  if (!isElectron) return null;

  const { src, labelKey } = ICONS[syncState];
  const toggleSync = syncState === 'sync-stopped' ? startSync : () => setStopDialogOpen(true);

  const confirmStop = () => {
    stopSync();
    setStopDialogOpen(false);
  };

  return (
    <>
      <StatusButton onClick={toggleSync} disabled={syncState === 'loading'}>
        <StatusIcon src={src} alt={t(labelKey)} />
      </StatusButton>
      {isStopDialogOpen && (
        <PatientSyncStopDialog onConfirm={confirmStop} onClose={() => setStopDialogOpen(false)} />
      )}
    </>
  );
}
